<template>
  <div class="ArticleDetail">
    <AppHeader logoLink="/" />
    <div class="main-page" v-if="articleTitle">
      <div class="article-title">{{ articleTitle }}</div>
      <div class="article-desc" v-html="decodeURIComponent(articleAbstract)" v-if="articleAbstract"></div>
      <div class="article-image" :style="imageBackground" v-if="imageBackground"></div>
      <div class="article-content" v-html="description" v-if="description"></div>
    </div>
    <AddonBuyerReso class="main-addon" />
    <div class="main-list">
      <div class="list-title">Explore San Francisco Neighborhoods</div>
      <MainArticleList @viewDetail="viewArticleDetail" />
    </div>
    <AppFooter />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter.vue'
import AddonBuyerReso from '../components/AddonBuyerReso'
import MainArticleList from '../components/MainArticleList'
import processImage from '@/common/processImage'

export default {
  name: 'ArticleDetail',
  components: { MainArticleList, AppHeader, AppFooter, AddonBuyerReso },
  data() {
    return {
      showArticle: null,
    }
  },
  computed: {
    description() {
      let description = this.article.content
      if (description) {
        return description.replace(
          '<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>',
          ''
        )
      }
      return description
    },
    ...mapGetters({
      getArticle: 'getArticle',
    }),
    article() {
      return this.getArticle
    },
    imageBackground() {
      let item = this.article
      if (item.attachment && item.attachment[0] && item.attachment[0].url) {
        let url = processImage.processImage(item.attachment[0].url, { resize: 'mid' })
        return "background-image: url('" + url + "')"
      }
      return false
    },
    articleContent() {
      let item = this.article
      if (item.content && item.content.length) {
        return item.content
      }
      return false
    },
    articleAbstract() {
      let item = this.article
      if (item.abstract && item.abstract.length) {
        let abstract = item.abstract
        abstract.replace(/san francisco/, "<span class='strong'>san francisco</span>")
        abstract.replace(/San Francisco/, "<span class='strong'>San Francisco</span>")
        return abstract
      }
      return false
    },
    articleTitle() {
      let item = this.article
      if (item.title && item.title.length) {
        return item.title
      }
      return false
    },
  },
  mounted() {
    this.getArticleDetail()
  },
  methods: {
    // getDescription() {
    //   let description = ''
    //   Object.assign(description, this.articleContent)
    //   description.replace(
    //     '<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>',
    //     ''
    //   )
    //   return description
    // },
    viewArticleDetail(item) {
      if (item) {
        location.href = `/article/${item.slug}`
      } else {
        this.getArticleDetail()
      }
    },
    getArticleDetail() {
      document.getElementById('app').scrollIntoView()
      if (!this.article.title) {
        this.loader = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        this.$axios({
          url: '/api/v1/client/estate/content/getContentDetail/' + this.$route.params.slug,
          method: 'get',
        })
          .then(res => {
            if (res.ok) {
              this.$store.commit('saveArticle', res.doc)
            }
            this.loader.close()
          })
          .catch(() => {
            console.error('error on GET:getContentDetail')
            this.loader.close()
          })
      }
    },
  },
}
</script>
<style scoped lang="less">
.ArticleDetail {
  width: 100%;

  .main-page {
    margin: 0 auto 65px;
    width: 960px;
    overflow-y: hidden;

    .article-title {
      margin: 65px 30px 20px;
      font-size: 18px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
    }

    .article-desc {
      margin: 0 30px;
      width: 731px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;

      .strong {
        color: rgba(153, 210, 13, 1);
      }
    }

    .article-image {
      margin: 20px 30px;
      height: 370px;
      background: no-repeat center center;
      background-size: cover;
    }

    .article-content {
      margin: 20px 30px;
      width: 900px;
      min-height: 200px;
      overflow-x: hidden;
    }
  }

  .main-addon {
    margin: 80px auto 65px;
    width: 100%;
  }

  .main-list {
    margin-bottom: 97px;
    padding-bottom: 40px;
    background-color: #f9f9f9;
    user-select: none;

    .list-title {
      margin: 0 auto;
      padding-top: 27px;
      width: 50%;
      height: 24px;
      font-size: 18px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      text-align: center;
    }
  }
}
</style>
